module.exports = __webpack_public_path__ + "static/report/img/w6.126052eb.png";